import "../styles/home.css";

const TEAM = {
  teamLead: ["Dr. Akram Khater"],
  leadScientists: ["Dr. Mehreen Saeed", "Dr. Chau Wai Wong"],
  softwareDevelopers: [
    "Ansh Ganatra",
    "Mahim Dashora",
    "Yash Mor",
    "Yash Shah",
    "Anandteertha Rao",
    "Smruthi BTM"
  ],
  archivists: [
    "Katelyn Cuomo",
    "Najma Mohamud",
    "Nour Makhlouf",
    "Rama Khalifeh",
  ],
};

const TeamSection = () => (
  <section className="team-section">
    <h2 className="team-section-heading">Meet the team</h2>
    <div className="team-section-content">
      <div className="team-block">
        <h3 className="team-role">Team Lead</h3>
        <ul className="team-list">
          {TEAM.teamLead.map((name) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      </div>
      <div className="team-block">
        <h3 className="team-role">Lead Scientists</h3>
        <ul className="team-list">
          {TEAM.leadScientists.map((name) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      </div>
      <div className="team-block">
        <h3 className="team-role">Software Developers</h3>
        <ul className="team-list">
          {TEAM.softwareDevelopers.map((name) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      </div>
      <div className="team-block">
        <h3 className="team-role">Archivists</h3>
        <ul className="team-list">
          {TEAM.archivists.map((name) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default TeamSection;
